import React, { useState, useEffect } from "react";
import { UserPlus, Save } from "lucide-react";
import { db } from "../../firebase/config";
import { doc, setDoc, collection, getDocs } from "firebase/firestore";
import { notifySuccess, notifyError } from "../../utils/alerts";

const RegistroAdministrador = () => {
  const [loading, setLoading] = useState(false);
  const [correo, setCorreo] = useState("");
  const [admins, setAdmins] = useState([]);

  const obtenerAdministradores = async () => {
    try {
      const querySnapshot = await getDocs(
        collection(db, "usuarios_autorizados"),
      );
      const lista = querySnapshot.docs
        .filter((doc) => doc.data().developer !== true)
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      setAdmins(lista);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    obtenerAdministradores();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await setDoc(doc(db, "usuarios_autorizados", correo), {
        email: correo,
        rol: "admin",
        fechaRegistro: new Date().toISOString(),
      });
      notifySuccess("¡Éxito!", "Administrador registrado correctamente");
      setCorreo("");
      obtenerAdministradores();
    } catch (error) {
      console.error(error);
      notifyError("Error", "No se pudo registrar el administrador");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto pb-20 space-y-4 sm:space-y-6">
      <header className="mb-4 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl font-black text-gray-800 tracking-tight">
          Registrar Administrador
        </h1>
        <p className="text-sm sm:text-base text-gray-500 font-medium">
          Agrega un correo autorizado para acceder al panel administrativo.
        </p>
      </header>

      <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
        <div className="bg-white p-5 sm:p-8 rounded-2xl sm:rounded-[2.5rem] shadow-sm border border-gray-100">
          <div className="flex items-center gap-3 mb-6 sm:mb-8">
            <div className="p-2 sm:p-3 bg-blue-100 text-blue-600 rounded-xl sm:rounded-2xl">
              <UserPlus size={20} className="sm:w-6 sm:h-6" />
            </div>

            <h2 className="text-lg sm:text-xl font-bold text-gray-800">
              Datos del Administrador
            </h2>
          </div>

          <div className="space-y-2">
            <label className="text-[10px] sm:text-xs font-black text-gray-400 uppercase ml-2 tracking-wider">
              Correo electrónico
            </label>

            <input
              type="email"
              required
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              placeholder="admin@correo.com"
              className="w-full py-3 px-4 sm:p-4 bg-gray-50 border-transparent focus:bg-white focus:ring-2 focus:ring-blue-500 rounded-xl sm:rounded-2xl outline-none transition-all text-sm sm:text-base"
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-black py-4 sm:py-5 rounded-2xl sm:rounded-[2rem] shadow-2xl shadow-blue-200 transition-all flex items-center justify-center gap-2 active:scale-[0.98]"
        >
          {loading ? (
            <div className="animate-spin rounded-full h-5 w-5 sm:h-6 sm:w-6 border-b-2 border-white"></div>
          ) : (
            <>
              <Save size={20} className="sm:w-[22px] sm:h-[22px]" />
              Registrar Administrador
            </>
          )}
        </button>
      </form>

      {/* LISTA DE ADMINISTRADORES */}

      <div className="mt-8 sm:mt-12 bg-white p-5 sm:p-8 rounded-2xl sm:rounded-[2.5rem] shadow-sm border border-gray-100">
        <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 sm:mb-6">
          Administradores Registrados
        </h2>

        {admins.length === 0 ? (
          <p className="text-sm sm:text-base text-gray-500">No hay administradores registrados.</p>
        ) : (
          <ul className="space-y-3">
            {admins.map((admin) => (
              <li
                key={admin.id}
                className="p-3 sm:p-4 bg-gray-50 rounded-xl sm:rounded-2xl flex flex-col sm:flex-row justify-between sm:items-center gap-2 sm:gap-0"
              >
                <span className="font-medium text-gray-700 text-sm sm:text-base truncate">{admin.email}</span>

                <span className="text-[10px] sm:text-xs font-bold text-blue-600 bg-blue-100 px-3 py-1 rounded-full self-start sm:self-auto">
                  {admin.rol}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default RegistroAdministrador;
